import React, { useRef } from 'react';
import { CtaOverlayButton } from '../../services/api/lpGenerationService';

interface CtaOverlayCanvasProps {
  imageUrl?: string;
  title: string;
  button: CtaOverlayButton;
  onChange: (button: CtaOverlayButton) => void;
}

const clamp = (value: number, min = 0, max = 100) => Math.max(min, Math.min(max, value));

const CtaOverlayCanvas: React.FC<CtaOverlayCanvasProps> = ({ imageUrl, title, button, onChange }) => {
  const frameRef = useRef<HTMLDivElement>(null);

  const updateFromPointer = (clientX: number, clientY: number) => {
    const rect = frameRef.current?.getBoundingClientRect();
    if (!rect) return;
    const centerX = ((clientX - rect.left) / rect.width) * 100;
    const centerY = ((clientY - rect.top) / rect.height) * 100;
    onChange({
      ...button,
      x_pct: Math.round(clamp(centerX - button.w_pct / 2)),
      y_pct: Math.round(clamp(centerY - button.h_pct / 2)),
    });
  };

  return (
    <div
      ref={frameRef}
      className="relative w-full max-w-[280px] aspect-[2/3] overflow-hidden rounded-md border border-warm-border bg-gray-100"
      onMouseDown={(event) => updateFromPointer(event.clientX, event.clientY)}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={title} className="block h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-xs text-gray-500">No image</div>
      )}
      <div
        data-testid="cta-overlay-rect"
        className="absolute border-2 border-dashed border-indigo-500 bg-indigo-500/10"
        style={{
          left: `${button.x_pct}%`,
          top: `${button.y_pct}%`,
          width: `${button.w_pct}%`,
          height: `${button.h_pct}%`,
        }}
      />
    </div>
  );
};

export default CtaOverlayCanvas;
